export const MODULE_NAME = 'websockets';
export const WEBSOCKET_RECONNECT_INTERVAL = 60 * 1000;
export const FORCE_RELOAD_INTERVAL = 30 * 60 * 1000;
export const SHOW_SNACKAR_INTERVAL = 20 * 60 * 1000;
